// src/components/Flex.tsx
import styled from "@emotion/styled";
import { jsx } from "@emotion/react/jsx-runtime";
function Flex({
  center = false,
  justify: justifyProp,
  align: alignProp,
  column = false,
  children,
  onClick,
  as = "div",
  overflow,
  whiteSpace,
  mr,
  ml
}) {
  const justify = justifyProp ? justifyProp : center ? "center" : "flex-start";
  const align = alignProp ? alignProp : center ? "center" : "flex-start";
  return /* @__PURE__ */ jsx(
    StyledFlex,
    {
      justify,
      align,
      column,
      as,
      onClick,
      cursorProp: onClick ? "pointer" : "unset",
      overflowProp: overflow,
      whiteSpace,
      mr,
      ml,
      children
    }
  );
}
var StyledFlex = styled.div`
  display: flex;
  text-overflow: ellipsis;

  ${({ column }) => column && `flex-direction: column;`}
  ${({ justify }) => `justify-content: ${justify};`}
  ${({ align }) => `align-items: ${align};`}
  ${({ cursorProp }) => `cursor: ${cursorProp};`}
  ${({ overflowProp }) => overflowProp ? `overflow: ${overflowProp}; max-width: 100%;` : ""}
  ${({ whiteSpace }) => whiteSpace ? `white-space: ${whiteSpace};` : ""}
  ${({ mr }) => mr ? `margin-right: ${typeof mr === "number" ? `${mr}px` : mr};` : ""}
  ${({ ml }) => ml ? `margin-left: ${typeof ml === "number" ? `${ml}px` : ml};` : ""}
`;

export {
  Flex
};
